// src/shared/types.ts
var AbbyEventType = /* @__PURE__ */ ((AbbyEventType2) => {
  AbbyEventType2[AbbyEventType2["PING"] = 0] = "PING";
  AbbyEventType2[AbbyEventType2["ACT"] = 1] = "ACT";
  return AbbyEventType2;
})(AbbyEventType || {});

export { AbbyEventType };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-OEWW7U5G.mjs.map